import { NewPasswordPage } from './NewPasswordPage';
import { LegacyPasswordPage } from './LegacyPasswordPage';
import { usePasswordPageDesign } from './usePasswordPageDesign';

export const PasswordPage: React.FC = () => {
  const { isResolved, isNewDesign } = usePasswordPageDesign();

  // Render nothing until the flag is known, otherwise the legacy design flashes first
  if (!isResolved) return null;

  return isNewDesign ? <NewPasswordPage /> : <LegacyPasswordPage />;
};
